export default __webpack_public_path__ + "static/media/Study__Textbook_16_9.b98e96ba.png";